import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "@store/store.tsx";
import ZoomVideo, {Participant} from "@zoom/videosdk";
import Controls from "./components/Controls.tsx";
import {MicOff, Person} from "@mui/icons-material";
import {joinCall} from "@store/callSlice.tsx";
import {LeaveCallURL} from "@config/api.ts";
import axios from "axios";
import EventHandler from "./components/EventHandler.tsx";
import BackArrowIcon from "@assets/icons/backArrowIcon.tsx";
import {MdFullscreen} from "react-icons/md";
import {Box, Typography} from "@mui/material";

let client = ZoomVideo.createClient();
client.init("en-US", "Global", {
    patchJsMedia: true,
    stayAwake: true,
    leaveOnPageUnload: true,
});

const Index = () => {
    const [micOn, setMicOn] = React.useState(false);
    const [videoOn, setVideoOn] = React.useState(false);
    const [started, setStarted] = React.useState(false);
    const dispatch = useDispatch<AppDispatch>();
    const [activeSpeaker, setActiveSpeaker] = React.useState<Participant | null>(null);
    const [allParticipants, setAllParticipants] = React.useState<Participant[]>(
        []
    );
    const {token, ticketId, hasVideo} = useSelector((state: any) => state.call);
    const {user} = useSelector((state: any) => state.user);
    const [currentUser, setCurrentUser] = React.useState<null | Participant>(
        null
    );
    const [showCallScreen, setShowCallScreen] = useState(false);

    React.useEffect(() => {
        return () => {
            axios.post(LeaveCallURL, {
                ticketId: ticketId,
                topic: ticketId.toString(),
                hasVideo: hasVideo,
                action: "ended",
            });
        };
    }, []);

    React.useEffect(() => {
        if (token) {
            client
                .join(
                    ticketId.toString(),
                    token,
                    `${user.firstName}` + " " + `${user.lastName}`,
                    ""
                )
                .then(() => {
                    setStarted(true);
                    setShowCallScreen(false)
                    dispatch(
                        joinCall({
                            ticketId: ticketId,
                            topic: ticketId.toString(),
                            hasVideo: hasVideo,
                            action: "incoming",
                        })
                    );
                    const stream = client.getMediaStream();
                    stream
                        .startAudio()
                        .then(() => {
                            setMicOn(true);
                        })
                        .catch(() => {
                            setMicOn(false);
                        });

                    const allParticipant: any[] = client.getAllUser();
                    setAllParticipants(allParticipant);
                    setCurrentUser(client.getCurrentUserInfo());
                    setActiveSpeaker(client.getCurrentUserInfo());
                });


        } else {
            client.leave();
        }

    }, [token]);

    const handleCallScreen = () => {
        setShowCallScreen(!showCallScreen);
    }

    return (
        <div
            className={
                showCallScreen ? "absolute bottom-[4rem] right-[1rem]  w-[50%]  md:max-w-[25%] xxl:max-w-[30%] bg-white z-[9999] flex flex-col draggable-item h-[35vh]" : "absolute top-0 left-0 h-[100vh] w-full bg-white z-[9999] flex flex-col !transform -translate-x-0 -translate-y-0"
            }
        >
            {showCallScreen ?
                <div className="flex items-center p-1 lg:p-2 justify-between">
                    <span>Call for Ticket: {ticketId}</span>
                    <MdFullscreen size={22} onClick={handleCallScreen} className="cursor-pointer"/>
                </div> :
                <div className={'py-2 flex items-center gap-5'}>
                    <Typography className="flex items-center p-2 cursor-pointer" onClick={handleCallScreen}>
                        <BackArrowIcon/>
                    </Typography>
                    <span>Call for Ticket: {ticketId}</span>
                </div>

            }

            <Box className={'flex flex-col lg:flex-row '} onClick={() => {
                if (showCallScreen) {
                    handleCallScreen();
                }
            }}>
                <video-player-container
                    class={`w-full !flex justify-center content-baseline overflow-x-auto ${showCallScreen ? "!h-[24vh]" : "h-[65vh] lg:h-[82vh]"}`}
                    id={'video-player-container-public'}>
                    <div
                        className={`w-full bg-slate-300 grid place-items-center absolute z-[-1] ${showCallScreen ? "h-[24vh]" : "h-[65vh] lg:h-[82vh]"}`}
                    >
                        {showCallScreen ?
                            <span className={"p-4 rounded-full bg-slate-500"}>
                          <Person style={{color: "white"}}/>
                      </span> :
                            <span className={"p-16 rounded-full bg-slate-500"}>
                            <Person style={{color: "white", fontSize: 100}}/>
                        </span>}
                    </div>
                    <div
                        className={`flex items-center gap-1 absolute bottom-0 right-0 ${showCallScreen ? "text-xs !pe-1" : "pe-5"} z-10`}>
                        <span
                            className={`text-white ${showCallScreen ? "text-xs" : ""}`}>{activeSpeaker?.displayName}</span>
                        {activeSpeaker?.muted === false ? <></> : <MicOff className={'!text-xs'} sx={{
                            color: "white"
                        }}/>}
                    </div>

                </video-player-container>
                {
                    !showCallScreen &&
                    <div
                        className={'p-2 flex lg:flex-col lg:h-[82vh] lg:overflow-y-scroll lg:w-[13vw] w-[100%] gap-2 overflow-x-scroll'}>
                        <div className={'gap-5 h-[17vh] lg:h-[15vh]  w-[32vw] md:w-[15vw] lg:w-[10vw]'}>
                            <video-player-container id={'video-player-container-self'}>
                                <div
                                    className={
                                        "h-full w-full bg-slate-300 grid place-items-center py-2 absolute z-[-1]"
                                    }
                                >
                                        <span className={"p-4 rounded-full bg-slate-500"}>
                                            <Person style={{color: "white", fontSize: {xs: "30", md: "40"}}}/>
                                        </span>
                                    <div className={'flex items-center gap-1'}>
                                        <span
                                            className={'text-black !text-xs '}>{currentUser?.displayName}</span>
                                        {currentUser?.muted === false ? <></> : <MicOff className={'!text-xs'} sx={{
                                            color: "black"
                                        }}/>}
                                    </div>
                                </div>
                            </video-player-container>
                        </div>
                        {
                            allParticipants.map((user) => {
                                if (user.userId !== activeSpeaker?.userId && user.userId !== currentUser?.userId)
                                    return <div className={'gap-5'} key={user.userId}>
                                        <div
                                            className={
                                                "h-[17vh] lg:h-[15vh]  w-[32vw] md:w-[15vw] lg:w-[10vw] bg-slate-300 grid place-items-center py-2"
                                            }
                                        >
                                        <span className={"p-4 rounded-full bg-slate-500"}>
                                            <Person style={{color: "white", fontSize: {xs: "30", md: "40"}}}/>
                                        </span>
                                            <div className={'flex items-center gap-1'}>
                                            <span
                                                className={'text-black !text-xs '}>{user?.displayName}</span>
                                                {user.muted === false ? <></> : <MicOff className={'!text-xs'} sx={{
                                                    color: "black"
                                                }}/>}
                                            </div>
                                        </div>
                                    </div>
                                return <></>
                            })
                        }
                    </div>
                }
            </Box>
            <EventHandler client={client} setAllParticipants={setAllParticipants}
                          setActiveSpeaker={setActiveSpeaker}
                          activeUser={activeSpeaker} myUser={currentUser} allParticipants={allParticipants}
                          setCurrentUser={setCurrentUser}/>
            <Controls
                micOn={micOn}
                setMicOn={setMicOn}
                videoOn={videoOn}
                setVideoOn={setVideoOn}
                started={started}
                currentUser={currentUser}
                activeSpeaker={activeSpeaker}
                showCallScreen={showCallScreen}
            />
        </div>
    );
};

export default Index;
